import React, { ReactElement } from 'react';
import { Typography, makeStyles, Container } from '@material-ui/core';
import { Fade } from 'react-awesome-reveal';
import { Helmet } from 'react-helmet';
import MapComponent from './map';
import logoImg from '../../images/logo.jpg';

const useStyles = makeStyles((theme) => ({
    title: {
        margin: '2rem 0',
        borderBottom: 'solid 1px #eee',
        paddingBottom: '0.5rem',
    },
    contentContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginBottom: '10rem',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
        },
    },
    companyNameText: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '1rem',
        [`& img`]: {
            width: 30,
            marginRight: '1rem',
        },
    },
    addressHeader: {
        fontWeight: 'bold',
        letterSpacing: '1px',
    },
    contactNumbers: {
        marginTop: '1rem',
        [`& a`]: {
            textDecoration: 'none',
            color: 'inherit',
        },
        [`& a:hover`]: {
            color: '#444',
        },
    },
    mapContainer: {
        [theme.breakpoints.down('sm')]: {
            marginTop: '2rem',
        },
    },
}));

function ContactPage(): ReactElement {
    const classes = useStyles();

    return (
        <Container maxWidth="md">
            <Helmet>
                <title>London Insulation Services | Contact</title>
            </Helmet>
            <Typography className={classes.title} variant="h3">
                Contact
            </Typography>
            <div className={classes.contentContainer}>
                <Fade>
                    <div>
                        <span className={classes.companyNameText}>
                            <img src={logoImg} alt="London Insulation Services" />
                            <Typography className={classes.addressHeader} variant="h6">
                                London Insulation Services
                            </Typography>
                        </span>
                        <a target="_blank" rel="noopener noreferrer" href="https://maps.app.goo.gl/mZZ2Jy1WtL6QH8NC6">
                            <Typography variant="subtitle1">
                                50 The Broadway, Leigh-on-sea
                                <br />
                                Essex, EC3R 6HD
                            </Typography>
                        </a>
                        <Typography className={classes.contactNumbers} color="textSecondary" variant="subtitle2">
                            <a href="mailto:daleygrant@londoninsulationservices.co.uk">
                                daleygrant@londoninsulationservices.co.uk
                            </a>
                        </Typography>
                    </div>
                    <div className={classes.mapContainer}>
                        <MapComponent />
                    </div>
                </Fade>
            </div>
        </Container>
    );
}

export default ContactPage;
